(function () {
  const COLLAPSED = "collapsed";
  const PARENT_EL = ".product-single__disclaimer";
  const BUTTON_EL = ".product-single__disclaimer__icon.caret";
  let buttonEl, parentEl;
  function initialize() {
    buttonEl = document.querySelector(BUTTON_EL);
    parentEl = document.querySelector(PARENT_EL);
    if (buttonEl && parentEl) {
      buttonEl.addEventListener("click", function (e) {
        parentEl.classList.toggle(COLLAPSED);
      });
    }
  }
  document.addEventListener("DOMContentLoaded", function () {
    initialize();
  });
})();
